<template>
    <div>
        <b-row class="pb-2">
            <b-col md="12" xl="6">
                <app-detalhe titulo="Número do Contrato" :size="size">
                    <strong>{{ contrato.vcCodigoEstruturado }}</strong>
                </app-detalhe>

                <app-detalhe titulo="Contrato RM" :size="size">
                    <app-status
                        :status="contrato.vinculoRM ? 'OK' : 'NOK'"
                        class="mr-2"
                        v-if="contrato.vinculoRM"
                    ></app-status>
                    <app-status
                        :status="contrato.contratoRM"
                        v-if="contrato.contratoRM"
                    ></app-status>
                </app-detalhe>

                <app-detalhe titulo="Fornecedor" :size="size">
                    <strong>
                        {{
                            contrato.fornecedor ? contrato.fornecedor.nome : ''
                        }}
                        <span
                            v-if="
                                contrato.fornecedor 
                                    && contrato.fornecedor.cnpj
                                    && !contrato.fornecedor.fornecedorExterno
                            "
                        >
                            | {{ contrato.fornecedor.cnpj }}</span
                        >
                        <span
                            v-if="
                                contrato.fornecedor 
                                    && contrato.fornecedor.codFornecedor
                                    && contrato.fornecedor.fornecedorExterno
                            "
                        >
                            | {{ contrato.fornecedor.codFornecedor }}</span
                        >
                        <span
                            v-if="
                                contrato.fornecedor && contrato.fornecedor.email
                            "
                        >
                            | {{ contrato.fornecedor.email }}</span
                        >
                        <span
                            v-if="
                                contrato.fornecedor &&
                                contrato.fornecedor.telefone
                            "
                        >
                            | {{ contrato.fornecedor.telefone }}</span
                        >
                    </strong>
                </app-detalhe>

                <app-detalhe titulo="Valor Global do Contrato" :size="size">
                    <strong>
                        {{ contrato.nuValorGlobalContrato | currency }}
                    </strong>
                </app-detalhe>

                <app-detalhe titulo="Saldo Previsto" :size="size">
                    <strong>{{ contrato.nuSaldoContrato | currency }}</strong>
                </app-detalhe>
                
                <app-detalhe titulo="Saldo Real" :size="size">
                    <strong>{{ contrato.nuSaldoContratoReal | currency }}</strong>
                </app-detalhe>

                <app-detalhe titulo="Situação" :size="size">
                    <app-status
                        :status="contrato.situacaoContrato.toUpperCase()"
                        v-if="contrato.situacaoContrato"
                    ></app-status>
                </app-detalhe>

                <app-detalhe titulo="Tipo do Contrato" :size="size">
                    <strong>
                        {{
                            contrato.tipoContrato
                                ? contrato.tipoContrato.toUpperCase()
                                : ''
                        }}
                    </strong>
                </app-detalhe>

                <app-detalhe titulo="Processo" :size="size">
                    <strong>{{ contrato.processo }}</strong>
                </app-detalhe>

                <app-detalhe titulo="Natureza de Despesa" :size="size">
                    <strong>
                        {{ contrato.codigoNatureza }} -
                        {{
                            contrato.natureza
                                ? contrato.natureza.toUpperCase()
                                : ''
                        }}
                    </strong>
                </app-detalhe>

                <app-detalhe titulo="Gestor" :size="size">
                    <strong>{{ contrato.solicitante }}</strong>
                </app-detalhe>

                <app-detalhe titulo="Gerente" :size="size">
                    <strong>{{ contrato.nomeGerente }}</strong>
                </app-detalhe>

                <app-detalhe titulo="Unidade" :size="size">
                    <strong>
                        {{
                            contrato.unidade
                                ? contrato.unidade.toUpperCase()
                                : ''
                        }}
                    </strong>
                </app-detalhe>

                <app-detalhe titulo="Objeto do Contrato" :size="size" v-if="contrato.isAditivo">
                    <strong>{{ contrato.objetoPrimeiroContrato }}</strong>
                </app-detalhe>

                <app-detalhe :titulo="tituloObjetoContrato" :size="size">
                    <strong>{{ contrato.vcObjetoContrato }}</strong>
                </app-detalhe>
            </b-col>
            <b-col md="12" xl="6">
                <app-detalhe titulo="Categoria" :size="size">
                    <strong>{{ contrato.categoria }}</strong>
                </app-detalhe>
                <app-detalhe titulo="Tipo da Contratação" :size="size">
                    <strong>{{ contrato.tipoContratacao }}</strong>
                </app-detalhe>
                <app-detalhe titulo="Tipo da Licitação" :size="size">
                    <strong
                        >{{ contrato.tipoLicitacao }}
                        <span v-if="contrato.numeroLicitacao"
                            >({{ contrato.numeroLicitacao }})</span
                        ></strong
                    >
                </app-detalhe>
                <app-detalhe titulo="Vigência" :size="size">
                    <strong>
                        {{
                            contrato.dtInicioVigencia
                                ? $moment(contrato.dtInicioVigencia).format(
                                      'DD/MM/YYYY'
                                  )
                                : ''
                        }}
                        a
                        {{
                            contrato.dtFimVigencia
                                ? $moment(contrato.dtFimVigencia).format(
                                      'DD/MM/YYYY'
                                  )
                                : ''
                        }}
                    </strong>
                </app-detalhe>

                <app-detalhe titulo="Prazo de Execução" :size="size">
                    <strong>
                        {{
                            contrato.dtInicioPrazoExecucao
                                ? $moment(
                                      contrato.dtInicioPrazoExecucao
                                  ).format('DD/MM/YYYY')
                                : ''
                        }}
                        a
                        {{
                            contrato.dtFimPrazoExecucao
                                ? $moment(contrato.dtFimPrazoExecucao).format(
                                      'DD/MM/YYYY'
                                  )
                                : ''
                        }}
                    </strong>
                </app-detalhe>
                <app-detalhe titulo="Garantia Contratual" :size="size">
                    <strong>
                        {{
                            contrato.flGarantiaContratual === 1 ? 'SIM' : 'NÃO'
                        }}
                    </strong>
                </app-detalhe>

                <app-detalhe
                    titulo="% Garantia"
                    :size="size"
                    v-if="contrato.flGarantiaContratual === 1"
                >
                    <strong>{{ contrato.nuPercentGarantia }}</strong>
                </app-detalhe>
                <app-detalhe
                    titulo="Total da Garantia"
                    :size="size"
                    v-if="contrato.flGarantiaContratual === 1"
                >
                    <strong>
                        {{
                            ((contrato.nuPercentGarantia *
                                contrato.nuValorGlobalContrato) /
                                100)
                                | currency
                        }}
                    </strong>
                </app-detalhe>
                <app-detalhe
                    titulo="Data Final da Garantia"
                    :size="size"
                    v-if="contrato.flGarantiaContratual === 1"
                >
                    <strong>
                        {{
                            contrato.dataFinalGarantia
                                ? $moment(contrato.dataFinalGarantia).format(
                                      'DD/MM/YYYY'
                                  )
                                : ''
                        }}
                    </strong>
                </app-detalhe>
                <app-detalhe
                    titulo="Tipo da Garantia"
                    :size="size"
                    v-if="contrato.flGarantiaContratual === 1"
                >
                    <strong>{{ contrato.tipoGarantia }}</strong>
                </app-detalhe>
                <app-detalhe
                    titulo="Garantia Apresentada"
                    :size="size"
                    v-if="contrato.flGarantiaContratual === 1"
                >
                    <app-status
                        :status="contrato.garantiaApresentada ? 'SIM' : 'NÃO'"
                    ></app-status>
                </app-detalhe>
                <app-detalhe
                    titulo="Observações da Garantia"
                    :size="size"
                    v-if="contrato.flGarantiaContratual === 1"
                >
                    <strong>{{ contrato.obsGarantia }}</strong>
                </app-detalhe>
                <app-detalhe titulo="Envio para o Fornecedor" :size="size">
                    <strong>
                        {{
                            contrato.dtEnvioFornecedor
                                ? $moment(contrato.dtEnvioFornecedor).format(
                                      'DD/MM/YYYY'
                                  )
                                : ''
                        }}
                    </strong>
                </app-detalhe>
                <app-detalhe titulo="Retorno do Fornecedor" :size="size">
                    <strong>
                        {{
                            contrato.dtRetornoFornecedor
                                ? $moment(contrato.dtRetornoFornecedor).format(
                                      'DD/MM/YYYY'
                                  )
                                : ''
                        }}
                    </strong>
                </app-detalhe>
                <app-detalhe titulo="Envio para a Diretoria" :size="size">
                    <strong>
                        {{
                            contrato.dtEnvioDiretoria
                                ? $moment(contrato.dtEnvioDiretoria).format(
                                      'DD/MM/YYYY'
                                  )
                                : ''
                        }}
                    </strong>
                </app-detalhe>
                <app-detalhe titulo="Retorno da Diretoria" :size="size">
                    <strong>
                        {{
                            contrato.dtRetornoDiretoria
                                ? $moment(contrato.dtRetornoDiretoria).format(
                                      'DD/MM/YYYY'
                                  )
                                : ''
                        }}
                    </strong>
                </app-detalhe>
                <app-detalhe
                    titulo="Início do Aditivo"
                    :size="size"
                    v-if="contrato.dtInicioVigenciaAditivo"
                >
                    <strong>
                        {{
                            contrato.dtInicioVigenciaAditivo
                                ? $moment(
                                      contrato.dtInicioVigenciaAditivo
                                  ).format('DD/MM/YYYY')
                                : ''
                        }}
                    </strong>
                </app-detalhe>
                <!-- <app-detalhe
                    titulo="Tipo do Movimento"
                    :size="size"
                    v-if="contrato.tipoMovimento"
                >
                    <strong>
                        {{ contrato.tipoMovimento }}
                    </strong>
                </app-detalhe> -->
            </b-col>
        </b-row>
    </div>
</template>

<script>
export default {
    props: {
        contrato: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            size: '170'
        }
    },

    methods: {},

    computed: {
        tituloObjetoContrato() {
            return `Objeto${ this.contrato.isAditivo ? ' do Aditivo': ''}`
        }
    },

    created() {},

    components: {}
}
</script>
